import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const StaffDeleteOrgModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "StaffDeleteOrgModalContainer" */
      './StaffDeleteOrgModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
